import { render, staticRenderFns } from "./_couponField.vue?vue&type=template&id=6e63c4cb"
import script from "./_couponField.vue?vue&type=script&lang=js"
export * from "./_couponField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports